import classnames from "classnames";

export const containerClass = ({ pos, size, top, btm }) =>
  classnames(
    `t-heading tt-heading-${size} margin-bottom-${btm} margin-top-${top} text-${pos}`
  );

